<template>
    <div class="inner-page">

        <AuthHeader />

        <!--~~~~~     PAGE CONTENT     ~~~~~-->
        <main class="inner-page__content  align-items-stretch  p-0">

            <div class="exam  w-100">

                <div class="exam__content">

                    <h1 class="exam__page-title  pt-3">{{getTranslation('identification')}}</h1>

                    <div class="exam__identification">

                        <div class="exam__data-group">
                            <label class="exam__data-label" for="personPin">{{ getTranslation('yourPin') }}</label>

                            <div class="d-flex">
                                <div class="exam__identification-field">
                                    <input class="field  field--full-width" maxlength="14" autocomplete="off" v-model.trim="pin" type="text" id="personPin" :class="{'field--error' : $v.pin.$error}">
                                </div>
                                <div class="exam__data-descr  m-0  pl-3  w-50">{{ getTranslation('yourPinExample') }}</div>
                            </div>
                        </div>

                        <div class="exam__data-group">
                            <label class="exam__data-label" for="password">{{ getTranslation('password') }}</label>

                            <div class="d-flex">
                                <div class="exam__identification-field">
                                    <input class="field  field--full-width" autocomplete="off" v-model.trim="password" type="password" id="password" :class="{'field--error' : $v.password.$error}">
                                </div>
                                <div class="exam__data-descr  m-0  pl-3  w-50">{{ getTranslation('adminPassword') }}</div>
                            </div>
                        </div>

                    </div>


                    <div class="exam__page-actions">
                        <a class="btn  btn--main" href="javascript:void(0)" @click="login">{{ getTranslation('signIn') }}</a>
                        <router-link :to="{name:'auth.identification'}" class="btn  btn--dark-outline">{{ getTranslation('toBack') }}</router-link>
                    </div>

                </div>
                <!-- /.exam__content -->

            </div>
            <!-- /.row -->

        </main>
        <!--~~~~~     / PAGE CONTENT     ~~~~~-->

        <Footer />

    </div>
</template>

<script>

    import AuthHeader from "./components/AuthHeader";
    import Footer from "../layouts/Footer";
    import required from "vuelidate/lib/validators/required";

    export default {
        name: "Login",
        components: { Footer, AuthHeader },
        data() {
            return {
                pin: '',
                password: '',
            }
        },
      updated() {
        this.setHeadings({
          title:this.getTranslation('identification')
        });
      },
        methods: {
            login() {
                this.$v.pin.$touch();
                this.$v.password.$touch();

                if ( this.$v.password.$invalid || this.$v.pin.$invalid )
                    return this.snotifyError( 'wrongFormMsg' );

                this.axios.post( this.$config.urls.candidateAuth.login.url, { pin: this.pin, token: this.password, lang: this.currentLocale } )
                    .then( response => {

                        this.setCandidateToken( response.data.data.token );

                        this.setCandidateAxiosHeader();

                        this.storeCandidate( response.data.data ).then( () => {
                            this.$router.push( { name: 'auth.success' } ).catch( () => {
                            } );
                        } );
                    } ).catch(()=>{});

            },
        },
        validations: {
            pin: {
                required
            },
            password: {
                required
            },
        }
    }
</script>

<style scoped>

</style>
